// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal';
import Button from '../common/Button';
// css
import '../../styles/components/account/CreateDSAWorkflowConversionConfirmationModal.scss';


class CreateDSAWorkflowConversionConfirmationModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      open,
      onCancel,
      onConfirm
    } = this.props;

    return (
      <Modal
        open={open}
        className={'account-dsa-list__create-dsa-workflow-conversion-confirmation-modal'}
        onDismiss={onCancel}
      >
        <h3>Clone to full DSA?</h3>
        <p>A New Customer DSA may be cloned to a full DSA when you are ready to have a conversation about indexing, Usage, &amp; Value Realization with the customer.</p>
        <div className='account-dsa-list__create-dsa-workflow-conversion-confirmation-modal__buttons'>
          <Button
            onClick={onCancel}
            label='Cancel'
          />
          <Button
            onClick={onConfirm}
            label='Clone'
            primary
          />
        </div>
      </Modal>
    );
  }
}

CreateDSAWorkflowConversionConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};

export default CreateDSAWorkflowConversionConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/account/CreateDSAWorkflowConversionConfirmationModal.js